const status_resolver = workflow => {
  return StatusId => {
    let status = "1";

    if (StatusId) {
      status = StatusId;
    }

    let status_item = workflow.status.find(item => {
      return item.id == status;
    });

    if (typeof status_item === "undefined") {
      status_item = workflow.status.find(item => {
        return item.description == status;
      });
    }

    if (typeof status_item === "undefined") {
      return this.status;
    } else {
      return status_item.description;
    }
  };
};
export default status_resolver;
